 let Modal = (() => {
    var html_header_template = ``;
    var html_body_template = ``;

    var init = function () {
        _bindClicks();
    }

    const createPaytomorrowModal = function () {
        jQuery('#tire-info-modal').modal('show');

        html_header_template = `
            <div class="commercial-image-strip">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/monro-brand-logo.png" alt="Monro Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/tirechoice-brand-logo.png" alt="Tirechoice Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/mrtire-brand-logo.png" alt="Mr. Tire Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/kentowery-brand-logo.png" alt="Ken Towery Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/tirebarn-brand-logo.png" alt="Tire Barn Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/carx-brand-logo.png" alt="Car-X Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/allentire-brand-logo.png" alt="Allen Tire Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/mountainview-brand-logo.png" alt="Mountainview Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/tirewarehouse-brand-logo.png" alt="Tire Warehouse Brand Logo">
            <img src="https://monro-images.s3.amazonaws.com/shared-images/monro-commercial-solutions-logo.png" alt="Monro Commercial Solutions Logo">
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        `;

        html_body_template = `
            <h2>Thanks for your request!</h2>
            <p>We appreciate your interest in obtaining a Drive Card Credit Card. After carefully reviewing your
            request, we cannot approve your Drive Card application now. But don’t worry! <strong>We have PayTomorrow
            payment plans that might work for you.</strong> Click the “Continue” button below to learn more or ask your
            Store Manager about our convenient PayTomorrow solutions.</p>
            <div class="paytomorrow-continue-container">
                <p>By selecting "Continue," you agree to be taken to the alternative 
                PayTomorrow payment plan options to complete your application.</p>
                <div class="paytomorrow-continue-btn-container">
                    <div class="paytomorrow-continue-btn">
                            <button class="paytomorrow-btn" onclick="location.href='/store-search/?paytomorrow'" type="button">Continue</button>
                    </div>
                    <div class="paytomorrow-logo">
                        <img class="paytomorrow-finance-logo" src="https://monro-images.s3.amazonaws.com/shared-images/PayTomorrow_Logo_Web_1550x339.png" alt="PayTomorrow Logo">
                    </div>
                </div>
            </div>
        `;
        const html_footer_template = `
        <p>*You agree that the alternative payment plan options will provide all required disclosures and terms and
        conditions for any offers.</p>
    `;

        jQuery('.tire-modal-header').html(html_header_template);
        jQuery('.tire-modal-body').html(html_body_template);
        jQuery('.tire-modal-footer').html(html_footer_template);
        jQuery('.modal-dialog').addClass("paytomorrow-modal-container");

        const storeID = Util.getCookie('store_location');

        if (storeID !== null) {
            jQuery.ajax({
                url: window.location.origin + `/wp-json/monro/v1/store?id=${storeID}`,
                type: 'GET',
                success: function(response) {
                    const store = response.data[0];
                    const paytomorrowBtnUrl = store["ptapplicationlink"];
                    jQuery('.paytomorrow-btn').attr("onclick", `location.href='${paytomorrowBtnUrl}'`);
                },
                error: function (response) {
                    console.log(response);
                }
            });
        } 
    }
    const createPrimeTransformersModal = function () {
        jQuery('#tire-info-modal').modal('show');

        html_header_template = `
        <button type="button" class="close transformers-modal-close-button" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
        </button>
        `;

        html_body_template = `
            <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Prime-Web-blank_UPDATED.jpg" alt="Transformers Prime background" class="transformers-modal-background-img">
            <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Transformers-only-in-theatres-june-9-reduced-1.png" alt="Transformers Logo" class="transformers-modal-logo-img">
            <div class="transformers-prime-modal-mobile-container">
                <button class="close transformers-modal-mobile-close-button" data-dismiss="modal">
                    <span class="transformers-modal-mobile-close-button-icon"></span>
                </button>
                <div class="transformers-prime-modal-mobile-img-container">
                    <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Prime-Mobile-blank_UPDATED-crop.jpg" alt="Transformers Prime Mobile background" class="transformers-modal-background-img-mobile">
                </div>
                <div class="transformers-prime-modal-mobile-text-container">
                    <ul>
                        <li>Watch the movie trailer</li>
                        <li>Learn how to get a free movie poster</li>
                        <li>Purchase movie tickets in advance</li>
                        <li>Browse special offers</li>
                    </ul>
                </div>
                <div class="transformers-prime-modal-mobile-trailer-btn-container">
                    <button class="trailer-button-mobile" onclick="window.location.href = '/project-v-draft'">VIEW TRAILER</button>
                </div>
            </div>
            <div class="transformers-modal-body-text">
                <ul>
                    <li>Watch the movie trailer</li>
                    <li>Learn how to get a free movie poster</li>
                    <li>Purchase movie tickets in advance</li>
                    <li>Browse special offers</li>
                </ul>
            </div>
            <button class="trailer-button" onclick="window.location.href = '/project-v-draft'">VIEW TRAILER</button>
        `;

        jQuery('.tire-modal-header').html(html_header_template);
        jQuery('.tire-modal-body').html(html_body_template);
        jQuery('.tire-modal-footer').hide();
        jQuery('.modal-dialog').addClass("transformers-modal-container");

        jQuery('.transformers-modal-close-button').click(function() {
            sessionStorage.setItem('transformerModalClosed', true);
        });
        jQuery('.transformers-modal-mobile-close-button-icon').click(function() {
            jQuery('.transformers-modal-background-img-mobile').toggleClass('hidden');
            sessionStorage.setItem('transformerMobileModalClosed', true);
        });
        
    }
    const createPrimalTransformersModal = function () {
        jQuery('#tire-info-modal').modal('show');

        html_header_template = `
        <button type="button" class="close transformers-modal-close-button" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
        </button>
        `;

        html_body_template = `
            <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Primal-Web-blank_UPDATED.jpg" alt="Transformers Primal background" class="transformers-modal-background-img">
            <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Transformers-only-in-theatres-june-9-reduced-1.png" alt="Transformers logo" class="transformers-modal-logo-img">
            <div class="transformers-prime-modal-mobile-container">
                <button class="close transformers-modal-mobile-close-button" data-dismiss="modal">
                    <span class="transformers-modal-mobile-close-button-icon"></span>
                </button>
                <div class="transformers-prime-modal-mobile-img-container">
                    <img src="https://monro.monrodev.mindex.cloud/wp-content/uploads/2023/05/Primal-mobile-blank_UPDATED-crop.jpg" alt="Transformers Prime Mobile background" class="transformers-modal-background-img-mobile">
                </div>
                <div class="transformers-prime-modal-mobile-text-container">
                    <ul>
                        <li>Watch the movie trailer</li>
                        <li>Learn how to get a free movie poster</li>
                        <li>Purchase movie tickets in advance</li>
                        <li>Browse special offers</li>
                    </ul>
                </div>
                <div class="transformers-prime-modal-mobile-trailer-btn-container">
                    <button class="trailer-button-mobile" onclick="window.location.href = '/project-v-draft'">VIEW TRAILER</button>
                </div>
            </div>
            <div class="transformers-modal-body-text">
                <ul>
                    <li>Watch the movie trailer</li>
                    <li>Learn how to get a free movie poster</li>
                    <li>Purchase movie tickets in advance</li>
                    <li>Browse special offers</li>
                </ul>
            </div>
            <button class="trailer-button" onclick="window.location.href = '/project-v-draft'">VIEW TRAILER</button>
        `;

        jQuery('.tire-modal-header').html(html_header_template);
        jQuery('.tire-modal-body').html(html_body_template);
        jQuery('.tire-modal-footer').hide();
        jQuery('.modal-dialog').addClass("transformers-modal-container");
        jQuery('.modal-dialog').addClass("transformers-primal-modal");

        jQuery('.transformers-modal-close-button').click(function() {
            sessionStorage.setItem('transformerModalClosed', true);
        });

        jQuery('.transformers-modal-mobile-close-button-icon').click(function() {
            jQuery('.transformers-modal-background-img-mobile').toggleClass('hidden');
            sessionStorage.setItem('transformerMobileModalClosed', true);
        });
        
    }

    var _bindClicks = function () {
        _sizeInfoCircleModal();
        _oeiModal();
        _recommendedInfoModal();
        _tireTypeModal();
        _topRatedModal();
        _warrantyInfoCircleModal()
        _bestSellerModal();
        _writeReviewModal();
        _sidewallInfoModal();
        _bestSellerModal();
        _topRatedModal();
        _utgqModal();
        _plyInfoCircleModal();
    }

    var _writeReviewModal = function () {
        jQuery(document).on('click', '.write-review', function (e) {
            e.preventDefault();
            let reviewUrl = jQuery(this).attr('href');
            html_header_template = `
                <h4 class="modal-title">
                    Write a Review
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            `;

            html_body_template = `
                <iframe src="${reviewUrl}" height="600px"></iframe>
            `;

            jQuery('.tire-modal-header').html(html_header_template);
            jQuery('.tire-modal-body').html(html_body_template);
            jQuery('.tire-modal-footer').css("display", "none");
            jQuery(".modal-dialog").css("max-width", "1000px");
        })
    }

    var _sidewallInfoModal = function () {
        jQuery(document).on('click', '.sidewall-info-circle', function () {
            html_header_template = `
                <h4 class="modal-title">
                    SIDEWALLS
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                <div style="width: 100%;">
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <h2>BLACKWALL</h2>
                        <img alt="Blackwall" style="margin-left: 20px; float: right; border: 1px solid #d2d2d2;" src="/wp-content/uploads/sidewallBlackwallExample.jpg">
                        "Blackwall" means the entire side of the tire is black and the letterning blends into the side. 
                        Most passenger and performance tires are "blackwall."
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <h2>WHITEWALL</h2>
                        <img alt="Whitewall" style="margin-left: 20px; float: right; border: 1px solid #d2d2d2;" src="/wp-content/uploads/sidewallWhitewallExample.jpg">
                        "Whitewall" means there is a white ring around the center of the tire. The lettering is black 
                        and blends into the side.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <h2>OUTLINED WHITE LETTERS</h2>
                        <img alt="Outlined White Letters" style="margin-left: 20px; float: right; border: 1px solid #d2d2d2;" src="/wp-content/uploads/sidewallOutlinedLettersExample.jpg">
                        "Outlined White Letters" means the lettering on the side of the tire is three dimensional. 
                        The lettering is outlined in white. This is common on Light Truck and SUV tires.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <h2>RAISED WHITE LETTERS</h2>
                        <img alt="Raised White Letters" style="margin-left: 20px; float: right; border: 1px solid #d2d2d2;" src="/wp-content/uploads/sidewallRaisedWhiteLetterExample.jpg">
                        Similar to "outlined white letters" but all of the letters are filled with white compared 
                        to just being outlined. This is common on Light Truck and SUV tires.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <h2>GOLD/WHITE</h2>
                        <img alt="Gold/White" style="margin-left: 20px; float: right; border: 1px solid #d2d2d2;" src="/wp-content/uploads/sidewallGoldStripeExample.jpg">
                        Some Vogue brand tires have a traditional gold strip on them. Some have both and gold and white stripe.
                    </div>
                </div>
            `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _sizeInfoCircleModal = function () {
        jQuery(document).on('click', '.size-info-circle', function () {
            html_header_template = `
                <h4 class="modal-title">
                    How to read tire size
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;

            jQuery('.tire-modal-header').html(html_header_template);


            html_body_template = `
                <h1>
                    <img alt="" src="https://monro-images.s3.amazonaws.com/shared-images/Tire-Sidewall-Markings-large.png" style="width: 500px; float: right; margin: 20px;">
                </h1>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #ed1b23;">
                    TIRE TYPE
                </h2>
                    <span style="color: #ed1b23;">P</span> = For passenger cars, SUVs, minivans and light trucks. LT = Heavy load trucks, vans or SUVs. There may not always be a letter in your tire size. 
                    A tire starting with "P185" can be replaced with a tire starting with "185" and vice versa. 
                    Most websites will not show the starting letter.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #069240;">
                    SECTION WIDTH
                </h2>
                    The <span style="color: #069240;">185</span> indicates this tire is 
                    <span style="color: #069240;">185</span> millimeters across from the widest point of its outer 
                    sidewall to the widest point of its inner sidewall when mounted and measured on a specified width wheel.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #00a9ee;">
                    ASPECT
                </h2>
                    Refers to the height of the sidewall (from rim to tread). In our example, the aspect of this tire is 
                    <span style="color: #00a9ee;">65%</span> of the of <span style="color: #069240;">185</span> 
                    millimeter width. The higher the number, the taller/thicker the sidewall.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #a37146;">
                    CONSTRUCTION
                </h2>
                    The <span style="color: #a37146;">"R"</span> in our example indicates this is a radial tire construction. 98% of tires have an 
                    <span style="color: #a37146;">"R"</span> construction.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #740000;">
                    DIAMETER
                </h2>
                    In our example, the diameter (the hole where your rim sits) is 
                    <span style="color: #740000;">15</span> inches across.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #818284;">
                    LOAD INDEX
                </h2>
                    The load index is how much weight the tire can support. Most vehicles come with a recommended tire load index. 
                    <span style="color: #ff0000;">SAFETY ALERT</span>: It is NOT recommended that you use a lower load index than 
                    the tires that came with your vehicle. You CAN use a higher load index.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                <h2 style="color: #ed1e7a;">
                    SPEED/PERFORMANCE RATING
                </h2>
                    The letter refers to the maximum speed the tire can travel and how the tire performs and handles. 
                    <span style="color: #ff0000;">SAFETY ALERT</span>: You should not "downgrade" the speed rating and 
                    all four tires should have the same speed rating.
                </div>
            `;

            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _warrantyInfoCircleModal = function () {
        // populate modal with WARRANTY specific content and some specific styling
        jQuery(document).on('click', '.warranty-info-circle', function () {
            html_header_template = `
                <h4 class="modal-title">
                    Tire Warranties
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            `;

            jQuery('.tire-modal-header').html(html_header_template);


            html_body_template = `
                <div style="overflow: hidden; margin-bottom: 10px;">
                The tire warranty indicates the number of miles the tire should last with proper care and maintenance.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                If a tire does not meet the mileage warranty, the customer will be issued a credit by the tire manufacture for the remaining tread depth on the tire.
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                For example, if a tire with a 50,000 mile limited warranty fails at 25,000 miles, the customer will be credited 50% because half of the tread was worn. See store for additional details.
                </div>
            `;

            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _tireTypeModal = function () {
        // populate modal with TYPE specific content and some specific styling
        jQuery(document).on('click', '.tire-type', function () {
            html_header_template = `
                <h4 class="modal-title">
                    Tire Types
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            `;

            jQuery('.tire-modal-header').html(html_header_template);


            html_body_template = `
                <div>
                    Tires are grouped into certain groups depending on the type of vehicle they are intended for.
                    <h2>
                        Competition Tire (Street Legal)
                    </h2>
                    D.O.T. street legal tires are not intended to be driven in snow, on ice or even on the street. 
                    These are special-use tires for racetrack or rally performance, and feature purposeful tread 
                    designs, high-grip tread compounds and tuned internal constructions to provide the ultimate in 
                    acceleration, cornering and braking traction for track and competition use.
                    <h2>
                        Standard Passenger Tire – All Seasons
                    </h2>
                    Performs in all seasons, including light snow. A dependable tires with good comfort and wear.
                    <h2>
                        High Performance Tire/High Performance Comfort – All Seasons
                    </h2>
                    Performs in all seasons, including light snow. Enhanced handling and performance over a 
                    passenger or touring tire.
                    <br>
                    <br>
                    <strong>
                        Note:
                    </strong> 
                    <em>
                        Low-profile, street-sport performance truck tires are also found in this group.
                    </em>
                    <h2>
                        Ultra High Performance – All Seasons and Summer
                    </h2>
                    Tires that are the best in its category. They use the latest technologies and materials to 
                    provide the best performance in its category. Designed for high performance applications in 
                    wet and dry conditions with advanced handling characteristics. High performance tires 
                    usually have a shorter tread life.
                    <h2>
                        Light Truck – Load Carrying, Standard Use, Off-Road Flotation and Sport
                    </h2>
                    A general tire for light truck and SUVs. All season applications. A dependable tire with good 
                    comfort and wear. Increased handling in bad weather conditions over a passenger or performance 
                    tire.
                    <br>
                    <br>
                    <strong>
                        Note:
                    </strong> 
                    <em>
                        Low-profile, street-sport performance truck tires are found in the "performance" group.
                    </em>
                    <h2>
                        Winter – Studdable and Non-Studdable
                    </h2>
                    For use in winter or colder conditions for increased safety. Winter tires stop 42% shorter 
                    than all-season tires in temperatures below 45 degrees when stopping from 35 miles per hour. 
                    Enhanced traction on snow and ice. Winter tires are not ideal for warmer temperatures because 
                    they have a louder ride and reduced tread life than all-season tires. Tires can be pinned or 
                    non-pinned for studding.
                </div>
            `;

            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _oeiModal = function () {
        jQuery(document).on('click', '.original-equipment-info-circle', function (e) {
            e.preventDefault();

            html_header_template = `
                <h4 class="modal-title">
                    Original Equipment
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                <p>
                    These are the tires this vehicle was equipped with from the automotive manufacturing factory
                </p>
            `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _recommendedInfoModal = function () {
        jQuery(document).on('click', '.recommended-info-circle', function (e) {
            e.preventDefault();
            html_header_template = `
                <h4 class="modal-title">
                    Our Recommendation
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                <p>
                    We recommend this tire based on overall performance and value
                </p>
            `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _bestSellerModal = function () {
        jQuery(document).on('click', '.best-seller-info-circle', function (e) {
            e.preventDefault();
            html_header_template = `
                <h4 class="modal-title">
                    Best Seller
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                <p>
                    These tires were purchased most often by our guests
                </p>
            `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _topRatedModal = function () {
        jQuery(document).on('click', '.top-rated-info-circle', function (e) {
            e.preventDefault();
            html_header_template = `
                <h4 class="modal-title">
                    Highest Rated
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                </button>
            `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                <p>
                    These tires have received the best reviews from our customers
                </p>
            `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _utgqModal = function () {
        jQuery(document).on('click', '.utqg-info-circle', function () {
            html_header_template = `
                    <h4 class="modal-title">
                        UTQG
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                    </button>
                `;
            jQuery('.tire-modal-header').html(html_header_template);

            html_body_template = `
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        The U.S. Department of Transportation requires most tires to have a Uniform Tire Quality Grading 
                        (or UTQG). The UTQG rates tires on treadwear, traction performance, and temperature resistance. 
                        The grade for each of these can be found on the sidewall of your tire.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        Note: Not all tires are required to have a UTQG. Deep light truck tires (off-road tires), 
                        temporary spare tires, snow tires, trailer tires, tires under 12” in diameter and other 
                        select tires.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                    <h2>TREADWEAR</h2>
                        Researchers drive a group of vehicles on a test track for 7,200 miles, some with test 
                        tires and some with control tires. Researchers then assign a rating based on the tread 
                        wear of the test tires versus the control tires.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        <strong>The rating pattern is:</strong>
                    </div>
                    <ul>
                        <li>100 = The test tire will last as long as the control tires</li>
                        <li>200 = The test tire will last twice as long as the control tires</li>
                        <li>300 = The test tire will last three times as long as the control tires</li>
                    </ul>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                        Some are critical on this system because it is open to interpretation. Comparing the 
                        treadwear grades of tire lines within a single brand can be helpful, however, 
                        comparing the grades between different brands is not recommended.
                    </div>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                    <h2>TRACTION GRADES</h2>
                        The UTQG traction grade rates the ability of your tire to stop on wet pavement. 
                        The lower the letter, the better the stopping ability. "AA" is the best, "C" is 
                        the worst.
                    </div>
                    <br>
                    <table class="table">
                        <tbody>
                            <tr>
                                <th>Grade</th>
                                <th>Asphalt g force</th>
                                <th>Concrete g force</th>
                            </tr>
                            <tr>
                                <td>AA</td>
                                <td>Above 0.54</td>
                                <td>0.41</td>
                            </tr>
                            <tr>
                                <td>A</td>
                                <td>Above 0.47</td>
                                <td>0.35</td>
                            </tr>
                            <tr>
                                <td>B</td>
                                <td>Above 0.38</td>
                                <td>0.26</td>
                            </tr>
                            <tr>
                                <td>C</td>
                                <td>Less Than 0.38</td>
                                <td>0.26</td>
                            </tr>
                        </tbody>
                    </table>
                    <br>
                    <div style="overflow: hidden; margin-bottom: 10px;">
                    <h2>TEMPERATURE (RESISTANCE) GRADES</h2>
                        Is the ability of your tire to dissipate heat generated by driving. Over time, 
                        heat can cause damage to your tires. Temperature resistance is given a "A," 
                        "B," or "C," rating. All tires sold in the United States must have at least a 
                        C rating.
                    </div>
                    <br>
                    <table class="table">
                        <tbody>
                            <tr>
                                <th>Temperature Grades</th>
                                <th>Speed</th>
                            </tr>
                            <tr>
                                <td>A</td>
                                <td>Over 115</td>
                            </tr>
                            <tr>
                                <td>B</td>
                                <td>Between 100 to 115</td>
                            </tr>
                            <tr>
                                <td>C</td>
                                <td>Between 85 to 100</td>
                            </tr>
                        </tbody>
                    </table>
                `;
            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    var _plyInfoCircleModal = function () {
        // populate modal with PLY specific content and some specific styling
        jQuery(document).on('click', '.ply-info-circle', function () {
            html_header_template = `
                <h4 class="modal-title">
                    PLY RATING
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            `;

            jQuery('.tire-modal-header').html(html_header_template);


            html_body_template = `
                <div style="overflow: hidden; margin-bottom: 10px;">
                Ply Rating refers to how many layers of nylon cord are embedded into the tire design. The higher the ply rating, the larger the load capacity and stiffer the tire will feel.  
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                4 Ply = Standard Load, Light Load, or Extra Load Tire
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                6 Ply = Load Range C
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                8 Ply = Load Range D
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                10 Ply = Load Range E
                </div>
                <div style="overflow: hidden; margin-bottom: 10px;">
                12 Ply = Load Range F
                </div>
            `;

            jQuery('.tire-modal-body').html(html_body_template);

            jQuery('.tire-modal-footer').css("display", "none");

            jQuery(".modal-dialog").css("max-width", "1000px");
        });
    }

    return {
        init: init,
        createPaytomorrowModal: createPaytomorrowModal,
        createPrimeTransformersModal: createPrimeTransformersModal,
        createPrimalTransformersModal: createPrimalTransformersModal
    }
})();